import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import appState from '../storages/mobx/appState';

class NotificationStatus extends Component {
  render() {
    return (
      !appState.notificationStatus ? (
        <div style={{
          width: '30%', display: 'flex', justifyContent: 'center', zIndex: 10000,
        }}
        >
          Notifications denied
          &nbsp;
          <button onClick={() => {
            Notification
              .requestPermission()
              .then((permission) => {
                if (permission === 'granted') appState.setNotificationStatus(true);
              });
          }}
          >
            Enable
          </button>
        </div>
      ) : null
    );
  }
}

NotificationStatus.propTypes = {};

export default observer(NotificationStatus);
